import { Media } from 'enums';
import styled from 'styled-components';

export const SelectorContainer = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  flex-wrap: nowrap;
  column-gap: 20px;
  justify-content: space-between;

  .month-selector {
    flex: 1 0 155px;

    @media ${Media.tablet} {
      flex: 1 0 186px;
    }
  }
`;
